import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
export const fetchGraphData = createAsyncThunk(
    "graph/fetchGraphData",
    async ({ userId, organizationId }, thunkAPI) => {
        try {
            const jwtToken = localStorage.getItem("jwt_token");
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/graph?user_id=${userId}&organisation_id=${organizationId}`,
                {
                    method: "GET",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${jwtToken}`,
                    },
                }
            );
            const result = await response.json();

            if (!response.ok || result.error) {
                throw new Error(result.error || "Failed to fetch graph data");
            }

            const formatData = (data) => {
                return {
                    labels: data.map((item) =>
                        item.label || ""
                    ), // "04 May"
                    points: data.map((item) => item.points ?? 0),
                };
            };

            return {
                weekly: formatData(result.data.weekly),
                monthly: formatData(result.data.monthly),
            };
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    }
);

const graphSlice = createSlice({
    name: "graph",
    initialState: {
        loading: false,
        error: null,
        weekly: { labels: [], points: [] },
        monthly: { labels: [], points: [] },
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchGraphData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchGraphData.fulfilled, (state, action) => {
                state.loading = false;
                state.weekly = action.payload.weekly;
                state.monthly = action.payload.monthly;
            })
            .addCase(fetchGraphData.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default graphSlice.reducer;
